import React from "react";
import { useNavigate } from "react-router-dom";
import "./EmployeeCardSetting.css";


const MASTER_MENUS = [
  {label: "導入", path: "/introduction", icon: "📖"},
  {label: "組織図マスター", path: "/departments", icon: "🏢"},
  //{ label: "部署マスター", path: "/departments", icon: "🏢" },
  { label: "会社マスター", path: "/company-config", icon: "🏭" },
  { label: "勤務地マスター", path: "/locations", icon: "📍" },
  { label: "社員マスター", path: "/admin/employee-master", icon: "👥" },
  { label: "有給休暇マスター", path: "/paidLeave", icon: "🎖️" },
  { label: "シフトマスター", path: "/shifts", icon: "📅" },
  { label: "プロジェクトマスター", path: "/admin/project-master", icon: "📁" },
  { label: "プロジェクトパターン", path: "/admin/project-patterns", icon: "📊" },
  { label: "役割権限", path: "/permissions/matrix", icon: ""},
  { label: "説明PDF管理", path: "/admin/feature-help", icon: "🛡️" },
];

const EmployeeCardSetting = () => {
  const navigate = useNavigate();

  return (
    <div className="ecs-page">
      <header className="ecs-header">
        <div className="ecs-title-block">
          <h1 className="ecs-title">マスタ管理設定</h1>
          <p className="ecs-subtitle">
            各種基本情報の登録・編集を行うマスターメニューを選択してください。
          </p>
        </div>
        <button type="button" className="ecs-btn-back" onClick={() => navigate("/dashboard")}>
          メニュー画面に戻る
        </button>
      </header>

      <div className="ecs-menu-grid">
        {MASTER_MENUS.map((menu, index) => (
          <button
            key={index}
            className="ecs-menu-card"
            onClick={() => navigate(menu.path)}
          >
            <span className="ecs-menu-icon">{menu.icon}</span>
            <span className="ecs-menu-label">{menu.label}</span>
            <span className="ecs-menu-arrow">→</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmployeeCardSetting;